import React from "react";
import $ from "jquery";
import "magnific-popup";
import CONSTANTS from "../constants";

class VideoSec extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    $(".VideoSec a").magnificPopup({
      disableOn: 700,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false,
    });
  }
  render() {
    return (
      <div className="VideoSec" id="videoSec">
        <a href="http://www.youtube.com/watch?v=kzwBgjB_ZLs" />
        <div className="videoWrap">
          <div
            className="video"
            style={{
              background:
                "center / 101% 101% url(" + CONSTANTS.video.img1 + ")",
            }}
            onClick={() =>
              window.open("https://www.youtube.com/watch?v=kzwBgjB_ZLs&t=2s")
            }
          />
          <div
            className="video"
            style={{
              background:
                "center / 101% 101% #eee url(" + CONSTANTS.video.img2 + ")",
            }}
            onClick={() =>
              window.open("https://www.youtube.com/watch?v=hfo6b_DrRlU&t=1s")
            }
          />
          <div
            className="video"
            style={{
              background:
                "center / 101% 101% url(" + CONSTANTS.video.img3 + ")",
            }}
            onClick={() =>
              window.open("https://www.youtube.com/watch?v=C6rNY4st7aM")
            }
          />
        </div>
      </div>
    );
  }
}

export default VideoSec;



// WEBPACK FOOTER //
// ./src/components/index/VideoSec.js